module.exports = __webpack_public_path__ + "img/zmxt.b7040a60.png";